// extracted by mini-css-extract-plugin
export var profileHeader = "styles-module__profileHeader___vGRTl";
export var link = "styles-module__link___CLdoJ";
export var deleteProfile = "styles-module__deleteProfile___aHIZT";